import React from "react";
import ThreeColWithSideImage from "components/features/ThreeColWithSideImage.js";
import SimpleWithSideImage from "components/faqs/SimpleWithSideImage.js";
import DashedBorderSixFeatures from "components/features/DashedBorderSixFeatures";
import Musthqbil from "pages/Musthaqbil";
import Layout from "components/layouts/Layout";
import JamiaCarousal from "components/carousel/JamiaCarousal";
import JamiaYoutube from "components/youtube/JamiaYoutube";
import StatsCounter from "components/features/StatsCounter";
import RecentPhotosSection from "components/photos/RecentPhotosSection";

import FacebookFeed from "components/FacebookFeed"; // adjust path if needed

import {
  FaQuran, // For Islamic message
  FaLandmark, // For Islamic heritage
  FaHandsHelping, // For social reform
  FaUserGraduate, // For scholars preparation
  FaBalanceScale, // For balanced education
  FaUserFriends, // For personality development
  FaMicrophoneAlt, // For speech and writing training
  FaGlobe, // For regional preachers
  FaHandshake, // For unity
  FaBookReader,
  FaGraduationCap,
  FaChalkboardTeacher,
  FaLaptop,
  FaUniversity,
  FaHospital,
  FaUserTie,
} from "react-icons/fa";
import DashboardGrid from "components/features/DashboardGrid";
import MustaqbilKeAzaim from "components/features/MustaqbilKeAzaim";

const myCards = [
  {
    Icon: FaBookReader,
    title: "سلفی منہج کی دعوت",
    description:
      "خالص سلفی فکر کو عام کرنا اور اس کی دعوت و اشاعت کو یقینی بنانا",
  },
  {
    Icon: FaGraduationCap,
    title: "معیاری نصاب تعلیم",
    description:
      "نصاب تعلیم کو معیاری بنانا اور جدید معاشرتی تقاضوں کے مطابق ایک مثالی نظام قائم کرنا۔",
  },
  {
    Icon: FaBalanceScale,
    title: "دینی و عصری علوم کا امتزاج",
    description:
      "دینی تعلیم کے ساتھ عصری علوم کی تدریس پر بھی خصوصی توجہ دینا۔",
  },
  {
    Icon: FaChalkboardTeacher,
    title: "تربیت پر خصوصی توجہ",
    description: "طلبہ کی اخلاقی و دینی تربیت کو اولین ترجیح دینا۔",
  },
  {
    Icon: FaLaptop,
    title: "جدید ٹیکنالوجی کا استعمال",
    description:
      "جدید ٹیکنالوجی کے ذریعے تعلیمی ترقی، مقابلہ جاتی سرگرمیوں اور ثقافتی پروگراموں کو فروغ دینا۔",
  },
  {
    Icon: FaUniversity,
    title: "جامعات سے الحاق",
    description:
      "مختلف قومی اور بین الاقوامی جامعات سے الحاق کے ذریعے تعلیمی معیار کو بلند کرنا۔",
  },
  {
    Icon: FaHospital,
    title: "بہترین سہولیات",
    description:
      "طلبہ کو قیام، طعام، علاج و معالجہ اور کھیل کے میدان میں بہترین سہولیات فراہم کرنا۔",
  },
  {
    Icon: FaUserTie,
    title: "ماہر اساتذہ کی نگرانی",
    description:
      "تعلیم و تربیت کو ماہر اور تجربہ کار اساتذہ کی زیر نگرانی انجام دینا۔",
  },
  {
    Icon: FaLandmark,
    title: "جنوبی ہند کا قدیم ادارہ",
    description:
      "جامعہ جنوبی ہند کا سب سے قدیم ادارہ ہے، جو اپنی تاریخی اہمیت اور خدمات کی وجہ سے ممتاز مقام رکھتا ہے",
  },
  // {
  //   Icon: FaHandHoldingHeart,
  //   title: "غریب و یتیم طلبہ کی کفالت",
  //   description:
  //     "مستحق، غریب اور یتیم طلبہ کی کفالت کرنا اور ان کے لیے خصوصی رعایت فراہم کرنا۔",
  // },
];

const agrazWohMaqasidCards = [
  {
    Icon: FaQuran,
    title: "اسلام کا پیغام عام کرنے کا عزم",
    description:
      " اللہ تعالیٰ کی بندگی اور اس کے دین کی سربلندی کے لیے اسلام کے پیغام کو تعلیم، تربیت اور دعوت کے ذریعے دنیا بھر میں عام کرنا۔",
  },
  {
    Icon: FaLandmark,
    title: "اسلامی ورثے کا تحفظ اور فروغ",
    description:
      " اسلامی تعلیمات، ثقافت اور سلف صالحین کی غیرت و روایات کا تحفظ اور اس کا فروغ انفرادی و اجتماعی طور پر کرنا۔",
  },
  {
    Icon: FaHandsHelping,
    title: "معاشرتی اصلاح اور دینی خدمت",
    description:
      "سماج میں دینی، ملی، دعوتی، اصلاحی، فلاحی اور رفاہی کردار ادا کرتے ہوئے معاشرے کی روحانی اور اخلاقی اصلاح کرنا۔",
  },
  {
    Icon: FaUserGraduate,
    title: "عصر حاضر کے لیے علماء و قائدین کی تیاری",
    description:
      "ایسے علماء و قائدین کی تیاری جو قرآن و سنت اور منہج سلف صالحین کی روشنی میں موجودہ دور کے چیلنجز کا سامنا کر سکیں...",
  },
  {
    Icon: FaBalanceScale,
    title: "دین و دنیا کی ہم آہنگ تربیت",
    description:
      "طلبہ کے اندر دین اور دنیا کی ہم آہنگ صلاحیتیں پیدا کرنا، تاکہ وہ دونوں جہانوں میں کامیاب ہوں۔",
  },
  {
    Icon: FaUserFriends,
    title: "طلبہ کی متوازن شخصیت سازی",
    description:
      "طلبہ کی شخصیت سازی میں اعتقادی، روحانی، علمی، عقلی، جسمانی، نفسیاتی اور اجتماعی پہلوؤں میں توازن پیدا کرنا۔",
  },
  {
    Icon: FaMicrophoneAlt,
    title: "طلبہ کی تقریر و تحریر اور تجوید کی تربیت",
    description:
      "طلبہ کو تقریر، تحریر، حفظِ قرآن اور تجوید کی مہارتوں میں تربیت دینا اور ان کی صلاحیتوں کو نکھارنا۔",
  },
  {
    Icon: FaGlobe,
    title: "علاقائی مبلغین کی تیاری",
    description:
      "علاقائی زبانوں میں ماہر مبلغین اور دعاۃ تیار کرنا تاکہ دین اسلام کے پیغام کو ہر طبقے تک پہنچایا جا سکے۔",
  },
  {
    Icon: FaHandshake,
    title: "اتحاد امت اور اختلافات کا خاتمہ",
    description:
      "امت مسلمہ کے اتحاد و اتفاق کو فروغ دینا اور امت کے درمیان موجود علمی و فکری اختلافات کو کتاب و سنت کی روشنی میں ختم کرنا۔",
  },
  // {
  //   Icon: FaGavel,
  //   title: "کردار سازی اور قیادت کی تربیت",
  //   description:
  //     "معاشرے میں انصاف، امن، اور عدل کے قیام کے لیے طلبہ کو کردار سازی اور عملی قیادت کی تربیت دینا۔",
  // },
];

const faqs = [
  {
    question: "بانی کا تعارف",
    answer:
      'سید اسماعیل السلفی رحمہ اللہ (۱۸۹۷ء-۱۹۸۳ء) کی پیدائش آندھرا پردیش کے ضلع اننت پور کے گاؤں "ہنور" میں ہوئی۔ انہوں نے عربی، اردو اور فارسی کی تعلیم حاصل کی اور مختلف علاقوں سے اسلامی علوم میں مہارت حاصل کرنے کے بعد جامعہ کی بنیاد رکھی۔',
  },
  {
    question: "جامعہ کی ترقی",
    answer:
      '۱۹۲۶ء میں ابتدائی طور پر قرآنی تعلیم دینے والے "مکتب" کے طور پر آغاز کے بعد، ۱۹۳۸ء میں رائیدرگ کی مرکزی سڑک پر ایک عمارت خریدی گئی جہاں ادارے کو رسمی شکل دی گئی۔ ۱۹۴۱ء تک یہاں مروجہ مدارس کے نصاب کے مطابق آٹھ سالہ تعلیمی نظام قائم کیا گیا۔',
  },
  {
    question: "تعلیمی نظام",
    answer:
      'ادارے میں متوسطہ، ثانویہ، عالمیہ، اور فضیلت کے تعلیمی مراحل شامل ہیں، جن کے مکمل ہونے پر طلبہ کو "شہادت الفضیلت" دی جاتی ہے۔',
  },
  {
    question: "وسیع خدمات",
    answer:
      'دینی تعلیم کے علاوہ، ادارے نے "دار الایتام" (یتیم خانہ)، سرکاری ابتدائیہ اسکول قائم کیے اور اسے "شری وینکٹیشورا یونیورسٹی" جیسی سرکاری جامعات کے مساوی حیثیت دی گئی۔',
  },
  {
    question: "وراثت اور اثرات",
    answer:
      "۱۹۴۷ء (ہندوستان کی آزادی کے سال) میں پہلی فارغ التحصیل جماعت کے بعد سے، جامعہ مسلسل ایسے اسلامی علماء تیار کر رہا ہے جو مختلف حیثیتوں میں، بطور مبلغ، دینی تنظیموں کے سربراہان، اور دیگر تعلیمی اداروں کے مدیران کے طور پر، پورے ہندوستان میں خدمات انجام دے رہے ہیں۔",
  },
];

export default () => (
  <>
    <Layout>
      {/* Hero Carousel Section */}
      <JamiaCarousal />
      <StatsCounter />

      <DashboardGrid />

      {/* Main Objectives Section with spacing */}
      <div style={{ marginTop: "4rem", marginBottom: "3rem" }}>
        <DashedBorderSixFeatures
          cards={agrazWohMaqasidCards}
          title="اغراض و مقاصد"
        />
      </div>

      {/* Features Section */}
      <div style={{ marginTop: "4rem", marginBottom: "3rem" }}>
        <ThreeColWithSideImage
          heading={"جامعہ کی خصوصیات"}
          subheading={""}
          description={""}
          cards={myCards}
        />
      </div>

      {/* Future Vision Section */}
      <div style={{ marginTop: "4rem", marginBottom: "3rem" }}>
        <MustaqbilKeAzaim />
      </div>

      {/* Statistics Section */}

      {/* Video Section */}
      <div style={{ marginTop: "4rem", marginBottom: "3rem" }}>
        <JamiaYoutube />
      </div>

      {/* Recent Photo Gallery Section */}
      <div style={{ marginTop: "4rem", marginBottom: "3rem" }}>
        <RecentPhotosSection />
      </div>

      {/* FAQ Section */}
      <div style={{ marginTop: "4rem", marginBottom: "3rem" }}>
        <SimpleWithSideImage
          faqs={faqs}
          description={
            'جامعہ محمدیہ عربیہ رائیدرگ جنوبی ہند میں واقع ایک معروف اسلامی تعلیمی ادارہ ہے، جو اپنی معیاری تعلیم اور اعلیٰ تربیت کے لیے مشہور ہے۔ اس درسگاہ کا قیام ۱۹۲۶ء میں سید اسماعیل السلفی رحمہ اللہ نے "انجمن محمدیہ" کے نام سے کیا تھا، جو بعد میں ایک جامع اسلامی تعلیمی ادارے میں تبدیل ہو گیا۔ بانی جامعہ نے ہندوستان کے مختلف علاقوں، خصوصاً خاندان غزنویہ اور مدرسہ سلفیہ پنجاب کے علماء، سے تعلیم حاصل کی۔ اب تک یہاں سے سینکڑوں علماء، حفاظ، دعاۃ اور مبلغین فارغ التحصیل ہو چکے ہیں، جو ملک اور بیرون ملک دینی خدمات انجام دے رہے ہیں'
          }
        />
      </div>

      {/* Social Feed Section */}
      <div style={{ marginTop: "4rem", marginBottom: "4rem" }}>
        <FacebookFeed />
      </div>
    </Layout>
  </>
);
